// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AttachmentThumbnail-cls1___f9c04f6672e64a78f33{/*!*/}.AttachmentThumbnail-cls2__ff5a23848d9bd6338f18{position:relative;box-shadow:0 1px 2px rgba(0,0,0,.1),0 8px 0 -3px #fff,0 8px 2px -2px rgba(0,0,0,.1),0 16px 0 -6px #fff,0 16px 2px -2px rgba(0,0,0,.05)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AttachmentThumbnail-cls1___f9c04f6672e64a78f33",
	"cls2": "AttachmentThumbnail-cls2__ff5a23848d9bd6338f18 AttachmentThumbnail-cls1___f9c04f6672e64a78f33"
};
export default ___CSS_LOADER_EXPORT___;
